export const countryCodes = {
  USA: 'USA',
  CANADA: 'CAN'
};

export const countryNames = {
  USA: 'United States of America',
  CANADA: 'Canada'
};
